module.exports = __webpack_public_path__ + "img/pf.11a69718.png";